import { useCallback, useEffect, useState } from 'react';
import {
  fetchAccountsReceivable,
  type AccountsReceivableSummary,
} from '../lib/invoices/fetchAccountsReceivable';

export function useAccountsReceivable(businessId: string | undefined) {
  const [summary, setSummary] = useState<AccountsReceivableSummary | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const load = useCallback(async () => {
    if (!businessId) {
      setSummary(null);
      setLoading(false);
      setError(null);
      return;
    }

    setLoading(true);
    setError(null);
    try {
      const data = await fetchAccountsReceivable(businessId);
      setSummary(data);
    } catch (err) {
      console.error('Error loading accounts receivable:', err);
      setError('Failed to load');
      setSummary(null);
    } finally {
      setLoading(false);
    }
  }, [businessId]);

  useEffect(() => {
    void load();
  }, [load]);

  return { summary, loading, error, refresh: load };
}
